/** Public site origin. Crawlers read this from index.html before JavaScript runs. */
export const MARKETING_ORIGIN = "https://www.zonaclara.io";

export function upsertMeta(attr: "name" | "property", key: string, content: string): void {
  const selector = `meta[${attr}="${key}"]`;
  let element = document.head.querySelector(selector);

  if (!(element instanceof HTMLMetaElement)) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

export function upsertLink(rel: string, href: string): void {
  const existing = document.head.querySelector(`link[rel="${rel}"]`);

  if (existing instanceof HTMLLinkElement) {
    existing.href = href;

    return;
  }

  const created = document.createElement("link");
  created.rel = rel;
  created.href = href;
  document.head.appendChild(created);
}
